import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import FaceIcon from '@material-ui/icons/Face';
import Typography from '@material-ui/core/Typography';
import getTimePassed from '../../util/passedTime';

const useStyles = makeStyles({
  avatarStyle: {
    marginRight: 5,
    fontSize: 25,
    height: 35,
    width: 35,
  },
  timePassedStyle: {
    fontSize: 12,
    color: 'grey',
  },
  containerStyle: {
    display: 'flex',
    flexDirection: 'row',
    padding: 10,
    flex: 1,
    alignItems: 'center',
    cursor: 'pointer',
  },
});

export default function Notification(props) {
  const classes = useStyles();
  const { notification, handleOnNotificationSelected } = props;

  const renderUserAvatar = notification.imageUrl
      ? (<Avatar className={classes.avatarStyle} src={notification.imageUrl} size={25} />)
      : (<Avatar className={classes.avatarStyle}><FaceIcon /></Avatar>);

  const timePassedStyle = {
    fontSize: 12,
    color: 'grey',
  };
  const containerColor = notification.state === 'New' || notification.state === 'Seen'
      ? { backgroundColor: '#D8F9E3' }
      : {};

  return (
    <div
      className={classes.containerStyle}
      style={containerColor}
      onClick={() => handleOnNotificationSelected(notification)}
    >

      {renderUserAvatar}
      <div style={{ marginRight: 10, marginLeft: 10 }}>
        <div dangerouslySetInnerHTML={{ __html: notification.content }} />
        <Typography style={timePassedStyle}>{getTimePassed(notification.date, true)}</Typography>
      </div>
    </div>
  );
}

Notification.propTypes = {
  notification: PropTypes.object.isRequired,
  handleOnNotificationSelected: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/main/notification-center/notification.js